import React from 'react';
import ReactDOM from 'react-dom';
import {ConnectedRouter} from "connected-react-router";
import {Provider} from 'react-redux';
import store from './store';
import App from 'pages/App';
import history from "./utils/history";

const MyApp = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App/>
      </ConnectedRouter>
    </Provider>
  );
};

ReactDOM.render(<MyApp />, document.getElementById('root'));
